/**
 * Shared chrome for the read-only replay of a visual element in chat history.
 * The caption explains a part's outcome — "Submitted", "Not answered." — where
 * the element itself can't show it.
 */
export const historyCaptionStyle = { margin: '12px 0 0', color: '#888', fontSize: 12 }
